import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import CellRendererLink from "@/components/optimization-group/list/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/optimization-group/list/cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "@/components/optimization-group/list/cell-renderer/CellRendererActions.vue";
import OptimizationGroupCreate from "@/components/optimization-group/create/OptimizationGroupCreate.vue";
import OptimizationGroupEdit from "@/components/optimization-group/edit/OptimizationGroupEdit.vue";

export const optimizationGroupListMixin = {
	name: "OptimizationGroupList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
				};
			},
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererLink,
		CellRendererStatus,
		CellRendererActions,
		OptimizationGroupCreate,
		OptimizationGroupEdit,
	},
	data() {
		return {
			isSidebarActive: false,
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Name",
			gridApi: null,
			gridOptions: {},
			isExactly: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererActions,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getOptimizationGroup(page);
		},
		quantityElementPage() {
			this.getOptimizationGroup(1);
		},
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_optimization_group;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_optimization_group;
		}
		this.getOptimizationGroup(1);
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 150,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
				},
				{
					headerName: this.$t("Routing.Table.Name"),
					field: "name",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Description"),
					field: "description",
					filter: filterHead,
					width: 350,
				},
				{
					headerName: this.$t("Group.TotalOptimizations"),
					field: "total_optimization",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Group.TotalCreated"),
					field: "total_created",
					filter: filterHead,
					width: 180,
				},
				{
					headerName: this.$t("Group.TotalProcessed"),
					field: "total_processing",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Group.TotalFinalized"),
					field: "total_finalized",
					filter: filterHead,
					width: 180,
				},
				{
					headerName: this.$t("Group.TotalErrors"),
					field: "total_error",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleOptimizationGroup.optimizationGroupList;
		},
		isSidebarEditActive() {
			return this.$store.state.moduleOptimizationGroup.isSidebarActiveEdit;
		},
		getInformationToUpdate() {
			return this.$store.state.moduleOptimizationGroup.optimizationGroupEditList;
		},
	},
	methods: {
		showSidebarEmit(val) {
			this.isSidebarActive = val;
		},
		showSidebarEdit(val) {
			this.$store.commit("moduleOptimizationGroup/SET_OPTIMIZATION_GROUP_SIDEBAR_ACTIVE", val);
		},
		closeSidebar() {
			this.$store.commit("moduleOptimizationGroup/SET_OPTIMIZATION_GROUP_SIDEBAR_ACTIVE", false);
		},
		getOptimizationGroup(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleOptimizationGroup/optimizationGroupFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		search() {
			const searchQueryList = this.searchQuery.map(({value}) => {
				if (this.searchField === "Id") return parseInt(value);
				return value;
			});
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleOptimizationGroup/optimizationGroupFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.getOptimizationGroup(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_optimization_group"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
};
